import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
// export interface User{
//   email:string;
// }

@Component({
  selector: 'app-edit-email-dialog',
  templateUrl: './edit-email-dialog.component.html',
  styleUrls: ['./edit-email-dialog.component.scss']
})
export class EditEmailDialogComponent implements OnInit {
  email:string;
  private user: User = new User();
  emailAdd: String = "";
  addresss: String = "";
  mobileNumber: String = "";
  public showMsg;
  mobileverifyMsg:string =""; //shows msg mobile verified or not
  custData: Observable<any>;
  private debugData: Boolean = true;  // to show and hide the data in console log
 otpErrorMsg: string = ""; // to display the error msg on otp popup
 
 
 constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
 private httpClient: HttpClient, private alertService: AlertService, 
 public dialogRef: MatDialogRef<EditEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User) {

}
onNoClick(): void {
  this.dialogRef.close();
}
ngOnInit() {
  this.initCustData();
 }
 
  
  initCustData() {
  if (this.apiService.checkUserLoggedIn() == true) {
  let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
  this.httpClient.get(urrr)
 .subscribe(
  data => this.intilizeComponent(data),
  error => this.showError(error)
 );
 
 } else {
  console.log("User Not Logged In. Please login!")
 }
 
 }
 
  intilizeComponent(data) {
  this.user = data;
  
   }
 
  showError(msg) {
  console.log("Error Found in server");
 }
  
  Error1(msg) {
  this.alertService.warn("");
 }
 updateEmailmsg: string = "";
  editEmail: string
  updateEmailAddress(emailAdd) {
  if (emailAdd != null) {
  if (this.apiService.checkUserLoggedIn() == true) {
  let postData = { 'email': emailAdd, 'id': this.user.id, 'type': 'email', 'oldEmail': this.user.email }
  this.httpClient.post(this.apiService.profileUpdateURL, postData)
 .subscribe(
 (detail: any) => {
  this.user = detail;
  this.updateEmailmsg = "Email Address Updated Successfully";
  this.initCustData()
  this.email=this.user.email;
  //console.log("GG", this.email);
 },
 (err) => {
  let errorEmail = err.error.message;
  if (errorEmail.indexOf("email") != -1) {
    this.updateEmailmsg = "Email already exist";
  }
}
 )
 } else {
  console.log("Please login");
 }
 }
  else {
  console.log("please add email address");
 }
 }
 
 
  

}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/edit-email-dialog/edit-email-dialog.component.ts